import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

const StyledMenuButton = styled(IconButton)<IconButtonProps>(({ theme }) => ({
  border: 'solid lightgray 1px',
  backgroundColor: 'white',
  borderRadius: '50%',
  position: 'absolute',
  height: 40,
  width: 40,
  top: '-20px',
  right: '8px',
  zIndex: 1,

  '&:hover, &:focus-visible': {
    border: `solid ${theme.palette.primary.main} 1px`,
    backgroundColor: 'white',
    color: theme.palette.primary.main,
  },
}));

export default StyledMenuButton;
